import axios from "../axios";
const endPoint = `/subcategory`

export const getbymain = async (main) => {
    return await axios.get(`${endPoint}/main_category_V2/${main}`)
}
export const gettotalcount = async (id) => {
    return await axios.get(`${endPoint}/count/${id}`)
}